import React from 'react';
import { X } from 'lucide-react';

/**
 * Compact single-line criterion editor used inside the admin KB card + create
 * form. Keeps its own state minimal — the parent form owns the criteria array.
 */
export const CriterionRow = ({ crit, idx, onChange, onRemove }) => (
  <div className="flex items-center gap-2 bg-white/5 rounded-lg px-3 py-2">
    <span className="text-white/20 text-xs w-5 text-right flex-shrink-0">{idx + 1}.</span>
    <input
      value={crit.description}
      onChange={e => onChange(idx, 'description', e.target.value)}
      placeholder="Criteria description..."
      className="flex-1 bg-transparent text-white text-sm placeholder-white/20 focus:outline-none"
    />
    <div className="flex items-center gap-1 flex-shrink-0">
      <span className="text-white/30 text-xs">Weight</span>
      <input
        type="number" min={1}
        value={crit.weight}
        onChange={e => onChange(idx, 'weight', parseInt(e.target.value) || 1)}
        className="w-14 bg-white/10 border border-white/10 rounded px-1.5 py-0.5 text-white text-xs text-center focus:outline-none focus:border-teal-500/50"
        title="Any positive integer — higher = more important"
      />
    </div>
    <button onClick={() => onRemove(idx)} className="text-white/20 hover:text-red-400 transition-colors ml-1">
      <X className="w-4 h-4" />
    </button>
  </div>
);
